/* eslint-disable import-x/first -- must capture timestamp before other modules execute */
const jsEntryStart = globalThis.performance.now();

import "expo-router/entry";
import "react-native-gesture-handler";

import ColdStartTracker from "@/services/ColdStartTracker";

ColdStartTracker.markJsEntryStart(jsEntryStart);
